module.exports = __webpack_public_path__ + "static/img/ys2.c3666983.png";